/**
 * TumblerCrop — extracts a single bottle from the KIVO product sprite (3×3 grid).
 *
 * The reference image is a 3-column / 3-row contact sheet. Each "cell" contains:
 *   [ specs panel on left | bottle photograph | shipping box ]
 * We treat each cell as 1/3 of the image width and 1/3 of the image height,
 * then bias the X axis to focus on the bottle (right-half of the cell).
 *
 * @param {0|1|2} row    0 = Corporate Chaos, 1 = Girls Club, 2 = Gen-Z
 * @param {0|1|2} col    column within that collection (0/1/2)
 */
const SHEET =
  'https://customer-assets.emergentagent.com/job_16c8c640-a514-4fa8-96ae-5ac9fbd4e856/artifacts/drzxgtv7_image.png';

export default function TumblerCrop({
  row = 0,
  col = 0,
  className = '',
  testId,
  zoom = 'bottle', // 'bottle' isolates the bottle, 'cell' shows the whole cell
}) {
  // Each cell is 33.33% of the full image. The bottle sits in the middle-right
  // of its cell. Using background-size 900%/300% (3× horizontal zoom on the cell),
  // and shifting X to ~58–62% within each cell to land on the bottle.
  const cellW = 33.333;
  const xCenterInCell = zoom === 'bottle' ? 0.58 : 0.5;

  // Calculate background-position-x as % of image width for the bottle center.
  // We're zoomed to 900% width, so each unit of background-position covers
  // (imageWidth - containerWidth) — we approximate with cell math:
  const bgSizeX = zoom === 'bottle' ? 900 : 300;
  const bgSizeY = 300;

  // Bottle X position in the source image (0–100%)
  const bottleX = col * cellW + xCenterInCell * cellW;
  // Convert to background-position-x percentage (image overflows container)
  const posX = (bottleX / (100 - 100 / (bgSizeX / 100))) * 100;

  // Bottle Y position centered in row
  const bottleY = row * cellW + 0.5 * cellW;
  const posY = (bottleY / (100 - 100 / (bgSizeY / 100))) * 100;

  return (
    <div
      data-testid={testId}
      className={className}
      style={{
        backgroundImage: `url(${SHEET})`,
        backgroundSize: `${bgSizeX}% ${bgSizeY}%`,
        backgroundPosition: `${posX}% ${posY}%`,
        backgroundRepeat: 'no-repeat',
      }}
      role="img"
      aria-label="KIVO tumbler"
    />
  );
}

export { SHEET as KIVO_SHEET };
